/**
 * @generated SignedSource<<2b2cd8658a0c77c58d0713e761be84e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NumbersBlock_content$data = {
  readonly highlightedText: string | null;
  readonly id: string;
  readonly numbers: {
    readonly data: ReadonlyArray<{
      readonly attributes: {
        readonly number: string;
        readonly title: string;
      } | null;
      readonly id: string | null;
    }>;
  } | null;
  readonly numbersTitle: string | null;
  readonly " $fragmentType": "NumbersBlock_content";
};
export type NumbersBlock_content$key = {
  readonly " $data"?: NumbersBlock_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"NumbersBlock_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NumbersBlock_content",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "numbersTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "highlightedText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NumberRelationResponseCollection",
      "kind": "LinkedField",
      "name": "numbers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NumberEntity",
          "kind": "LinkedField",
          "name": "data",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Number",
              "kind": "LinkedField",
              "name": "attributes",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "number",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ComponentContentNumbers",
  "abstractKey": null
};
})();

(node as any).hash = "57140a6c681c037447337f79337c1f3f";

export default node;
